"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupResultsFlowEventListeners = exports.setupNoviceFlowEventListeners = void 0;
var logic_1 = require("./logic");
var config_1 = require("./config");
var collapsible_1 = require("@rmlibrary/collapsible");
var tween_1 = require("@rmlibrary/tween");
var lang = document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
// result filter section
var filterSection = document.getElementById("filter-list");
var resultsPageFilterAccordion = new collapsible_1.default(filterSection, 799, tween_1.Easing.easeOut);
// toggle buttons for accordion
var toggleButtonIcon = document.querySelector(".filter-toggle-button-before");
var toggleButton = document.querySelector(".filter-toggle-button");
// nav buttons
var nextButton = document.getElementById("next-button");
var backButton = document.getElementById("back-button");
// Check if mobile
var isMobile = "ontouchstart" in document.documentElement && navigator.userAgent.match(/Mobi/);
// current sort
var sortObj = { columnNum: 0, isAscending: true };
function focusSection(section, selector) {
    var heading = section.querySelector(selector);
    if (!heading)
        return;
    heading.tabIndex = -1;
    heading.style.outline = "none";
    heading.focus();
    setTimeout(function () {
        var rect = heading.getBoundingClientRect();
        var scrollingElement = document.scrollingElement || document.documentElement;
        scrollingElement.scrollTop = rect.top;
    }, 10);
}
function getLabel(input) {
    var _a;
    return (_a = input.labels) === null || _a === void 0 ? void 0 : _a.item(0);
}
/**
 * Setup event listeners for each filter button on the novice page.
 */
function setupNoviceFlowEventListeners() {
    // novice filter sections
    var assetClassesSection = document.querySelector(".asset-classes");
    var equityRegionsSection = document.querySelector(".equity-regions");
    var equityStrategiesSection = document.querySelector(".equity-strategies");
    var fixedIncomeStrategiesSection = document.querySelector(".fixed-income-strategies");
    var balancedStrategiesSection = document.querySelector(".balanced-strategies");
    // asset type filters
    var equityButtonNovice = document.getElementById("equity-novice");
    var fixedIncomeButtonNovice = document.getElementById("fixed-income-novice");
    var balancedButtonNovice = document.getElementById("balanced-novice");
    var commodityButtonNovice = document.getElementById("commodity-novice");
    // equity region filters
    var globalButtonNovice = document.getElementById("global-novice");
    var usaButtonNovice = document.getElementById("usa-novice");
    var canadaButtonNovice = document.getElementById("canada-novice");
    var emergingMarketsButtonNovice = document.getElementById("emerging-markets-novice");
    var notSureRegionButtonNovice = document.getElementById("not-sure-region-novice");
    // equity strategy filters
    var indexTrackButtonNovice = document.getElementById("index-tracking-novice");
    var industryButtonNovice = document.getElementById("industry-novice");
    var dividendButtonNovice = document.getElementById("dividend-novice");
    var innovationButtonNovice = document.getElementById("innovation-novice");
    var esgButtonNovice = document.getElementById("esg-novice");
    var usListedButtonNovice = document.getElementById("us-listed-novice");
    var otherStrategyButtonNovice = document.getElementById("other-novice");
    var notSureEquityStrategyButtonNovice = document.getElementById("not-sure-equity-strategy-novice");
    // fixed income strategy filters
    var corpInvestmentButtonNovice = document.getElementById("corp-investment-novice");
    var corpNonInvestmentButtonNovice = document.getElementById("corp-non-investment-novice");
    var governmentButtonNovice = document.getElementById("government-novice");
    var notSureFixedIncomeStrategyButtonNovice = document.getElementById("not-sure-fixed-income-strategy-novice");
    // balanced strategy filters
    var mediumLowButtonNovice = document.getElementById("medium-low-novice");
    var highTrackButtonNovice = document.getElementById("high-novice");
    var notSureBalancedStrategyButtonNovice = document.getElementById("not-sure-balanced-strategy-novice");
    // asset types
    var equityButton = document.getElementById("equity");
    var fixedIncomeButton = document.getElementById("fixed-income");
    var balancedButton = document.getElementById("balanced");
    var commodityButton = document.getElementById("commodity");
    var regionFilters = Array.from(document.querySelectorAll("#region-list input"));
    var regionLabels = Array.from(document.querySelectorAll("#region-list label"));
    var equityStrategyFilters = Array.from(document.querySelectorAll("#strategy-equity-list input"));
    var equityStrategyLabels = document.querySelectorAll("#strategy-equity-list label");
    var fixedIncomeStrategyFilters = Array.from(document.querySelectorAll("#strategy-fixed-income-list input"));
    var fixedIncomeStrategyLabels = document.querySelectorAll("#strategy-fixed-income-list label");
    var balancedStrategyFilters = Array.from(document.querySelectorAll("#strategy-balanced-list input"));
    var balancedStrategyLabels = document.querySelectorAll("#strategy-balanced-list label");
    setupResultsNavListeners();
    setupNoviceFlowDefinitionHovers();
    setupSelectedFilterText();
    // setting up event listeners for accordion
    if (toggleButton) {
        var toggleButtonIcon_1 = document.querySelector(".filter-toggle-button-before");
        [toggleButton, toggleButtonIcon_1].forEach(function (btn) {
            btn.addEventListener("click", function (e) {
                e.preventDefault();
                toggleAccordion(toggleButtonIcon_1, toggleButton);
            });
        });
    }
    backButton === null || backButton === void 0 ? void 0 : backButton.addEventListener("click", function (e) {
        e.preventDefault();
        if (!equityRegionsSection.classList.contains("hidden")) {
            equityRegionsSection.classList.add("hidden");
            assetClassesSection.classList.remove("hidden");
            nextButton.disabled = !equityButtonNovice.checked;
            backButton.classList.add("hidden");
            focusSection(assetClassesSection, "h3");
        }
        else if (!equityStrategiesSection.classList.contains("hidden")) {
            equityStrategiesSection.classList.add("hidden");
            equityRegionsSection.classList.remove("hidden");
            focusSection(equityRegionsSection, "h3");
        }
        else if (!balancedStrategiesSection.classList.contains("hidden")) {
            balancedStrategiesSection.classList.add("hidden");
            assetClassesSection.classList.remove("hidden");
            nextButton.disabled = !balancedButtonNovice.checked;
            backButton.classList.add("hidden");
            focusSection(assetClassesSection, "h3");
        }
        else if (!fixedIncomeStrategiesSection.classList.contains("hidden")) {
            fixedIncomeStrategiesSection.classList.add("hidden");
            assetClassesSection.classList.remove("hidden");
            nextButton.disabled = !fixedIncomeButtonNovice.checked;
            backButton.classList.add("hidden");
            focusSection(assetClassesSection, "h3");
        }
        else {
            equityRegionsSection.classList.add("hidden");
            equityStrategiesSection.classList.add("hidden");
            balancedStrategiesSection.classList.add("hidden");
            fixedIncomeStrategiesSection.classList.add("hidden");
            assetClassesSection.classList.remove("hidden");
            nextButton.disabled = true;
            backButton.classList.add("hidden");
            focusSection(assetClassesSection, "h3");
        }
    });
    nextButton === null || nextButton === void 0 ? void 0 : nextButton.addEventListener("click", function (e) {
        var _a, _b, _c;
        e.preventDefault();
        // if the asset classes section is hidden (equity, fixed income, balanced, commodity filter)
        if (!assetClassesSection.classList.contains("hidden")) {
            assetClassesSection.classList.add("hidden");
            backButton.classList.remove("hidden");
            if (equityButtonNovice.checked) {
                equityRegionsSection.classList.remove("hidden");
                focusSection(equityRegionsSection, "h3");
            }
            else if (fixedIncomeButtonNovice.checked) {
                fixedIncomeStrategiesSection.classList.remove("hidden");
                focusSection(fixedIncomeStrategiesSection, "h3");
            }
            else if (balancedButtonNovice.checked) {
                balancedStrategiesSection.classList.remove("hidden");
                focusSection(balancedStrategiesSection, "h3");
            }
            else {
                // there is no commodity section so just go straight to results page
                showResultsSection();
                (_a = document.getElementById("filter-collapse")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
                fetchDataAndPopulateFundTable().then(function () {
                    showSelectedFilterIcons();
                    hideAccordion(toggleButtonIcon, toggleButton);
                });
            }
            // if next button is within the region selection section
        }
        else if (!equityRegionsSection.classList.contains("hidden")) {
            equityRegionsSection.classList.add("hidden");
            // Selects all opt-btn-wrappers in equity strategies section
            var btnWrappers = equityStrategiesSection.getElementsByClassName("opt-btn-wrapper");
            // unhides the empty btn-wrapper divs
            for (var index = 3; index < 6; index++) {
                var element = btnWrappers[index].classList.remove("hidden");
            }
            // if emerging markets button is selected and no other region filter is selected, go straight to results page.
            if (emergingMarketsButtonNovice.checked &&
                !canadaButtonNovice.checked &&
                !usaButtonNovice.checked &&
                !globalButtonNovice.checked &&
                !notSureRegionButtonNovice.checked) {
                showResultsSection();
                (_b = document.getElementById("filter-collapse")) === null || _b === void 0 ? void 0 : _b.classList.remove("hidden");
                fetchDataAndPopulateFundTable().then(function () {
                    showSelectedFilterIcons();
                    hideAccordion(toggleButtonIcon, toggleButton);
                });
            }
            else {
                // if canada button is selected and no other region is selected hide innovation, esg and uslisted filters.
                if (canadaButtonNovice.checked &&
                    !usaButtonNovice.checked &&
                    !globalButtonNovice.checked &&
                    !notSureRegionButtonNovice.checked) {
                    getLabel(innovationButtonNovice).classList.add("hidden-important");
                    getLabel(esgButtonNovice).classList.add("hidden-important");
                    getLabel(usListedButtonNovice).classList.add("hidden-important");
                    innovationButtonNovice.classList.add("hidden-important");
                    esgButtonNovice.classList.add("hidden-important");
                    usListedButtonNovice.classList.add("hidden-important");
                    // hides the empty btn-wrapper divs
                    for (var index = 3; index < 6; index++) {
                        var element = btnWrappers[index].classList.add("hidden");
                    }
                }
                else {
                    getLabel(innovationButtonNovice).classList.remove("hidden-important");
                    getLabel(esgButtonNovice).classList.remove("hidden-important");
                    getLabel(usListedButtonNovice).classList.remove("hidden-important");
                    innovationButtonNovice.classList.remove("hidden-important");
                    esgButtonNovice.classList.remove("hidden-important");
                    usListedButtonNovice.classList.remove("hidden-important");
                }
                equityStrategiesSection.classList.remove("hidden");
                focusSection(equityStrategiesSection, "h3");
            }
            // if the next button exists outside region section and asset type section (i.e. next button must exist in one of the strategy sections)
        }
        else {
            showResultsSection();
            (_c = document.getElementById("filter-collapse")) === null || _c === void 0 ? void 0 : _c.classList.remove("hidden");
            fetchDataAndPopulateFundTable().then(function () {
                showSelectedFilterIcons();
                hideAccordion(toggleButtonIcon, toggleButton);
            });
        }
    });
    //setting up event listeners
    equityButtonNovice === null || equityButtonNovice === void 0 ? void 0 : equityButtonNovice.addEventListener("change", function () {
        nextButton.disabled = false;
        if (equityButtonNovice.checked) {
            if (config_1.filterOptions.assetClass.indexOf(config_1.filterStringObj.assetClass.equity) <= -1) {
                config_1.filterOptions.assetClass.push(config_1.filterStringObj.assetClass.equity);
                config_1.filterOptions.assetClass = filterOutOfArray(config_1.filterOptions.assetClass, [
                    config_1.filterStringObj.assetClass.all,
                    config_1.filterStringObj.assetClass.fixedIncome,
                    config_1.filterStringObj.assetClass.balanced,
                    config_1.filterStringObj.assetClass.commodity,
                ]);
                uncheckFilters([], true, equityButtonNovice);
                config_1.filterOptions.fixedIncomeStrategy = [];
                config_1.filterOptions.balancedStrategy = [];
                equityButton.checked = true;
                enableFilters(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true));
                regionLabels.forEach(function (label) { return label.classList.remove("inactive"); });
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
                disableFilters(fixedIncomeStrategyFilters);
                fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
                disableFilters(balancedStrategyFilters);
                balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
        }
    });
    fixedIncomeButtonNovice === null || fixedIncomeButtonNovice === void 0 ? void 0 : fixedIncomeButtonNovice.addEventListener("change", function () {
        nextButton.disabled = false;
        if (fixedIncomeButtonNovice.checked) {
            if (config_1.filterOptions.assetClass.indexOf(config_1.filterStringObj.assetClass.fixedIncome) <= -1) {
                config_1.filterOptions.assetClass.push(config_1.filterStringObj.assetClass.fixedIncome);
                config_1.filterOptions.assetClass = filterOutOfArray(config_1.filterOptions.assetClass, [
                    config_1.filterStringObj.assetClass.all,
                    config_1.filterStringObj.assetClass.equity,
                    config_1.filterStringObj.assetClass.balanced,
                    config_1.filterStringObj.assetClass.commodity,
                ]);
                uncheckFilters([], true, fixedIncomeButtonNovice);
                config_1.filterOptions.equityStrategy = [];
                config_1.filterOptions.balancedStrategy = [];
                fixedIncomeButton.checked = true;
                enableFilters(fixedIncomeStrategyFilters);
                fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
                disableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
                disableFilters(balancedStrategyFilters);
                balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
        }
    });
    balancedButtonNovice === null || balancedButtonNovice === void 0 ? void 0 : balancedButtonNovice.addEventListener("change", function () {
        nextButton.disabled = false;
        if (balancedButtonNovice.checked) {
            if (config_1.filterOptions.assetClass.indexOf(config_1.filterStringObj.assetClass.balanced) <= -1) {
                config_1.filterOptions.assetClass.push(config_1.filterStringObj.assetClass.balanced);
                config_1.filterOptions.assetClass = filterOutOfArray(config_1.filterOptions.assetClass, [
                    config_1.filterStringObj.assetClass.all,
                    config_1.filterStringObj.assetClass.equity,
                    config_1.filterStringObj.assetClass.fixedIncome,
                    config_1.filterStringObj.assetClass.commodity,
                ]);
                config_1.filterOptions.fixedIncomeStrategy = [];
                config_1.filterOptions.equityStrategy = [];
                uncheckFilters([], true, balancedButtonNovice);
                balancedButton.checked = true;
                enableFilters(balancedStrategyFilters);
                balancedStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
                disableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
                disableFilters(fixedIncomeStrategyFilters);
                fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
        }
    });
    commodityButtonNovice === null || commodityButtonNovice === void 0 ? void 0 : commodityButtonNovice.addEventListener("change", function () {
        nextButton.disabled = false;
        if (commodityButtonNovice.checked) {
            if (config_1.filterOptions.assetClass.indexOf(config_1.filterStringObj.assetClass.commodity) <= -1) {
                config_1.filterOptions.assetClass.push(config_1.filterStringObj.assetClass.commodity);
                config_1.filterOptions.assetClass = filterOutOfArray(config_1.filterOptions.assetClass, [
                    config_1.filterStringObj.assetClass.all,
                    config_1.filterStringObj.assetClass.equity,
                    config_1.filterStringObj.assetClass.fixedIncome,
                    config_1.filterStringObj.assetClass.balanced,
                ]);
                config_1.filterOptions.balancedStrategy = [];
                config_1.filterOptions.fixedIncomeStrategy = [];
                config_1.filterOptions.equityStrategy = [];
                uncheckFilters([], true, commodityButtonNovice);
                commodityButton.checked = true;
            }
        }
    });
    // start of the region event listeners
    globalButtonNovice === null || globalButtonNovice === void 0 ? void 0 : globalButtonNovice.addEventListener("change", function () {
        var globalButton = document.getElementById("global");
        setupListener(globalButtonNovice, config_1.filterStringObj.regions.global, "region", false);
        if (globalButtonNovice.checked) {
            globalButton.checked = true;
            notSureRegionButtonNovice.checked = false;
        }
        else {
            globalButton.checked = false;
        }
    });
    usaButtonNovice === null || usaButtonNovice === void 0 ? void 0 : usaButtonNovice.addEventListener("change", function () {
        var usaButton = document.getElementById("usa");
        setupListener(usaButtonNovice, config_1.filterStringObj.regions.us, "region", false);
        if (usaButtonNovice.checked) {
            usaButton.checked = true;
            notSureRegionButtonNovice.checked = false;
        }
        else {
            usaButton.checked = false;
        }
    });
    canadaButtonNovice === null || canadaButtonNovice === void 0 ? void 0 : canadaButtonNovice.addEventListener("change", function () {
        var canadaButton = document.getElementById("canada");
        setupListener(canadaButtonNovice, config_1.filterStringObj.regions.canada, "region", false);
        if (canadaButtonNovice.checked) {
            canadaButton.checked = true;
            notSureRegionButtonNovice.checked = false;
        }
        else {
            canadaButton.checked = false;
        }
    });
    emergingMarketsButtonNovice === null || emergingMarketsButtonNovice === void 0 ? void 0 : emergingMarketsButtonNovice.addEventListener("change", function () {
        var emergingMarketsButton = document.getElementById("emerging-markets");
        setupListener(emergingMarketsButtonNovice, config_1.filterStringObj.regions.emergingMarkets, "region", false);
        if (emergingMarketsButtonNovice.checked) {
            emergingMarketsButton.checked = true;
            notSureRegionButtonNovice.checked = false;
        }
        else {
            emergingMarketsButton.checked = false;
        }
    });
    // no specific regions means all regions
    notSureRegionButtonNovice === null || notSureRegionButtonNovice === void 0 ? void 0 : notSureRegionButtonNovice.addEventListener("change", function () {
        var globalButton = document.getElementById("global");
        var usaButton = document.getElementById("usa");
        var canadaButton = document.getElementById("canada");
        var emergingMarketsButton = document.getElementById("emerging-markets");
        if (notSureRegionButtonNovice.checked) {
            globalButtonNovice.checked = false;
            usaButtonNovice.checked = false;
            canadaButtonNovice.checked = false;
            emergingMarketsButtonNovice.checked = false;
            if (config_1.filterOptions.region.indexOf(config_1.filterStringObj.regions.global) <= -1) {
                config_1.filterOptions.region.push(config_1.filterStringObj.regions.global);
            }
            if (config_1.filterOptions.region.indexOf(config_1.filterStringObj.regions.canada) <= -1) {
                config_1.filterOptions.region.push(config_1.filterStringObj.regions.canada);
            }
            if (config_1.filterOptions.region.indexOf(config_1.filterStringObj.regions.us) <= -1) {
                config_1.filterOptions.region.push(config_1.filterStringObj.regions.us);
            }
            if (config_1.filterOptions.region.indexOf(config_1.filterStringObj.regions.emergingMarkets) <= -1) {
                config_1.filterOptions.region.push(config_1.filterStringObj.regions.emergingMarkets);
            }
        }
        else {
            if (!globalButtonNovice.checked) {
                config_1.filterOptions.region = config_1.filterOptions.region.filter(function (a) { return a !== config_1.filterStringObj.regions.global; });
            }
            if (!canadaButtonNovice.checked) {
                config_1.filterOptions.region = config_1.filterOptions.region.filter(function (a) { return a !== config_1.filterStringObj.regions.canada; });
            }
            if (!usaButtonNovice.checked) {
                config_1.filterOptions.region = config_1.filterOptions.region.filter(function (a) { return a !== config_1.filterStringObj.regions.us; });
            }
            if (!emergingMarketsButtonNovice.checked) {
                config_1.filterOptions.region = config_1.filterOptions.region.filter(function (a) { return a !== config_1.filterStringObj.regions.emergingMarkets; });
            }
        }
        checkFilters([globalButton, usaButton, canadaButton, emergingMarketsButton]);
    });
    // start of the equity strategy event listeners
    indexTrackButtonNovice === null || indexTrackButtonNovice === void 0 ? void 0 : indexTrackButtonNovice.addEventListener("change", function () {
        var indexTrackButton = document.getElementById("index-tracking");
        setupListener(indexTrackButtonNovice, config_1.filterStringObj.equityStrategy.indexTracking, "equityStrategy", false);
        if (indexTrackButtonNovice.checked) {
            indexTrackButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            indexTrackButton.checked = false;
        }
    });
    industryButtonNovice === null || industryButtonNovice === void 0 ? void 0 : industryButtonNovice.addEventListener("change", function () {
        var industryButton = document.getElementById("industry");
        setupListener(industryButtonNovice, config_1.filterStringObj.equityStrategy.industry, "equityStrategy", false);
        if (industryButtonNovice.checked) {
            industryButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            industryButton.checked = false;
        }
    });
    dividendButtonNovice === null || dividendButtonNovice === void 0 ? void 0 : dividendButtonNovice.addEventListener("change", function () {
        var dividendButton = document.getElementById("dividend");
        setupListener(dividendButtonNovice, config_1.filterStringObj.equityStrategy.dividend, "equityStrategy", false);
        if (dividendButtonNovice.checked) {
            dividendButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            dividendButton.checked = false;
        }
    });
    innovationButtonNovice === null || innovationButtonNovice === void 0 ? void 0 : innovationButtonNovice.addEventListener("change", function () {
        var innovationButton = document.getElementById("innovation");
        setupListener(innovationButtonNovice, config_1.filterStringObj.equityStrategy.innovation, "equityStrategy", false);
        if (innovationButtonNovice.checked) {
            innovationButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            innovationButton.checked = false;
        }
    });
    esgButtonNovice === null || esgButtonNovice === void 0 ? void 0 : esgButtonNovice.addEventListener("change", function () {
        var esgButton = document.getElementById("esg");
        setupListener(esgButtonNovice, config_1.filterStringObj.equityStrategy.esg, "equityStrategy", false);
        if (esgButtonNovice.checked) {
            esgButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            esgButton.checked = false;
        }
    });
    usListedButtonNovice === null || usListedButtonNovice === void 0 ? void 0 : usListedButtonNovice.addEventListener("change", function () {
        var usListedButton = document.getElementById("us-listed");
        setupListener(usListedButtonNovice, config_1.filterStringObj.currency.usd, "currency", true);
        if (usListedButtonNovice.checked) {
            usListedButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            usListedButton.checked = false;
        }
    });
    otherStrategyButtonNovice === null || otherStrategyButtonNovice === void 0 ? void 0 : otherStrategyButtonNovice.addEventListener("change", function () {
        var otherStrategyButton = document.getElementById("other-strategy");
        setupListener(otherStrategyButtonNovice, config_1.filterStringObj.equityStrategy.other, "equityStrategy", false);
        if (otherStrategyButtonNovice.checked) {
            otherStrategyButton.checked = true;
            notSureEquityStrategyButtonNovice.checked = false;
        }
        else {
            otherStrategyButton.checked = false;
        }
    });
    // no specific strategy means all strategies
    notSureEquityStrategyButtonNovice === null || notSureEquityStrategyButtonNovice === void 0 ? void 0 : notSureEquityStrategyButtonNovice.addEventListener("change", function () {
        var indexTrackButton = document.getElementById("index-tracking");
        var industryButton = document.getElementById("industry");
        var dividendButton = document.getElementById("dividend");
        var innovationButton = document.getElementById("innovation");
        var esgButton = document.getElementById("esg");
        var usListedButton = document.getElementById("us-listed");
        var otherStrategyButton = document.getElementById("other-strategy");
        if (notSureEquityStrategyButtonNovice.checked) {
            indexTrackButtonNovice.checked = false;
            industryButtonNovice.checked = false;
            dividendButtonNovice.checked = false;
            innovationButtonNovice.checked = false;
            esgButtonNovice.checked = false;
            usListedButtonNovice.checked = false;
            otherStrategyButtonNovice.checked = false;
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.indexTracking) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.indexTracking);
            }
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.industry) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.industry);
            }
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.dividend) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.dividend);
            }
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.innovation) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.innovation);
            }
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.esg) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.esg);
            }
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.usListed) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.usListed);
            }
            if (config_1.filterOptions.equityStrategy.indexOf(config_1.filterStringObj.equityStrategy.other) <= -1) {
                config_1.filterOptions.equityStrategy.push(config_1.filterStringObj.equityStrategy.other);
            }
        }
        else {
            if (!indexTrackButtonNovice.checked) {
                config_1.filterOptions.equityStrategy = config_1.filterOptions.equityStrategy.filter(function (a) { return a !== config_1.filterStringObj.equityStrategy.indexTracking; });
            }
            if (!industryButtonNovice.checked) {
                config_1.filterOptions.equityStrategy = config_1.filterOptions.equityStrategy.filter(function (a) { return a !== config_1.filterStringObj.equityStrategy.industry; });
            }
        }
        checkFilters([
            indexTrackButton,
            industryButton,
            dividendButton,
            innovationButton,
            esgButton,
            usListedButton,
            otherStrategyButton,
        ]);
    });
    // start of the fixed income strategy event listeners
    corpInvestmentButtonNovice === null || corpInvestmentButtonNovice === void 0 ? void 0 : corpInvestmentButtonNovice.addEventListener("change", function () {
        var corpInvestmentButton = document.getElementById("corp-investment");
        setupListener(corpInvestmentButtonNovice, config_1.filterStringObj.fixedIncomeStrategy.corporate, "fixedIncomeStrategy", false);
        if (corpInvestmentButtonNovice.checked) {
            corpInvestmentButton.checked = true;
            notSureFixedIncomeStrategyButtonNovice.checked = false;
        }
        else {
            corpInvestmentButton.checked = false;
        }
    });
    corpNonInvestmentButtonNovice === null || corpNonInvestmentButtonNovice === void 0 ? void 0 : corpNonInvestmentButtonNovice.addEventListener("change", function () {
        var corpNonInvestmentButton = document.getElementById("corp-non-investment");
        setupListener(corpNonInvestmentButtonNovice, config_1.filterStringObj.fixedIncomeStrategy.nonCorporate, "fixedIncomeStrategy", false);
        if (corpNonInvestmentButtonNovice.checked) {
            corpNonInvestmentButton.checked = true;
            notSureFixedIncomeStrategyButtonNovice.checked = false;
        }
        else {
            corpNonInvestmentButton.checked = false;
        }
    });
    governmentButtonNovice === null || governmentButtonNovice === void 0 ? void 0 : governmentButtonNovice.addEventListener("change", function () {
        var governmentButton = document.getElementById("government");
        setupListener(governmentButtonNovice, config_1.filterStringObj.fixedIncomeStrategy.government, "fixedIncomeStrategy", false);
        if (governmentButtonNovice.checked) {
            governmentButton.checked = true;
            notSureFixedIncomeStrategyButtonNovice.checked = false;
        }
        else {
            governmentButton.checked = false;
        }
    });
    notSureFixedIncomeStrategyButtonNovice === null || notSureFixedIncomeStrategyButtonNovice === void 0 ? void 0 : notSureFixedIncomeStrategyButtonNovice.addEventListener("change", function () {
        var corpInvestmentButton = document.getElementById("corp-investment");
        var corpNonInvestmentButton = document.getElementById("corp-non-investment");
        var governmentButton = document.getElementById("government");
        if (notSureFixedIncomeStrategyButtonNovice.checked) {
            corpInvestmentButtonNovice.checked = false;
            corpNonInvestmentButtonNovice.checked = false;
            governmentButtonNovice.checked = false;
            if (config_1.filterOptions.fixedIncomeStrategy.indexOf(config_1.filterStringObj.fixedIncomeStrategy.corporate) <= -1) {
                config_1.filterOptions.fixedIncomeStrategy.push(config_1.filterStringObj.fixedIncomeStrategy.corporate);
            }
            if (config_1.filterOptions.fixedIncomeStrategy.indexOf(config_1.filterStringObj.fixedIncomeStrategy.nonCorporate) <= -1) {
                config_1.filterOptions.fixedIncomeStrategy.push(config_1.filterStringObj.fixedIncomeStrategy.nonCorporate);
            }
            if (config_1.filterOptions.fixedIncomeStrategy.indexOf(config_1.filterStringObj.fixedIncomeStrategy.government) <= -1) {
                config_1.filterOptions.fixedIncomeStrategy.push(config_1.filterStringObj.fixedIncomeStrategy.government);
            }
        }
        else {
            if (!corpInvestmentButtonNovice.checked) {
                config_1.filterOptions.fixedIncomeStrategy = config_1.filterOptions.fixedIncomeStrategy.filter(function (a) { return a !== config_1.filterStringObj.fixedIncomeStrategy.corporate; });
            }
            if (!corpNonInvestmentButtonNovice.checked) {
                config_1.filterOptions.fixedIncomeStrategy = config_1.filterOptions.fixedIncomeStrategy.filter(function (a) { return a !== config_1.filterStringObj.fixedIncomeStrategy.nonCorporate; });
            }
            if (!governmentButtonNovice.checked) {
                config_1.filterOptions.fixedIncomeStrategy = config_1.filterOptions.fixedIncomeStrategy.filter(function (a) { return a !== config_1.filterStringObj.fixedIncomeStrategy.government; });
            }
        }
        checkFilters([corpInvestmentButton, corpNonInvestmentButton, governmentButton]);
    });
    // start of the balanced strategy event listeners
    mediumLowButtonNovice === null || mediumLowButtonNovice === void 0 ? void 0 : mediumLowButtonNovice.addEventListener("change", function () {
        var mediumLowButton = document.getElementById("medium-low");
        setupListener(mediumLowButtonNovice, config_1.filterStringObj.balancedStrategy.mediumLow, "balancedStrategy", false);
        if (mediumLowButtonNovice.checked) {
            mediumLowButton.checked = true;
            notSureBalancedStrategyButtonNovice.checked = false;
        }
        else {
            mediumLowButton.checked = false;
        }
    });
    highTrackButtonNovice === null || highTrackButtonNovice === void 0 ? void 0 : highTrackButtonNovice.addEventListener("change", function () {
        var highTrackButton = document.getElementById("high");
        setupListener(highTrackButtonNovice, config_1.filterStringObj.balancedStrategy.high, "balancedStrategy", false);
        if (highTrackButtonNovice.checked) {
            highTrackButton.checked = true;
            notSureBalancedStrategyButtonNovice.checked = false;
        }
        else {
            highTrackButton.checked = false;
        }
    });
    notSureBalancedStrategyButtonNovice === null || notSureBalancedStrategyButtonNovice === void 0 ? void 0 : notSureBalancedStrategyButtonNovice.addEventListener("change", function () {
        var mediumLowButton = document.getElementById("medium-low");
        var highTrackButton = document.getElementById("high");
        if (notSureBalancedStrategyButtonNovice.checked) {
            mediumLowButton.checked = false;
            highTrackButton.checked = false;
            if (config_1.filterOptions.balancedStrategy.indexOf(config_1.filterStringObj.balancedStrategy.mediumLow) <= -1) {
                config_1.filterOptions.balancedStrategy.push(config_1.filterStringObj.balancedStrategy.mediumLow);
            }
            if (config_1.filterOptions.balancedStrategy.indexOf(config_1.filterStringObj.balancedStrategy.high) <= -1) {
                config_1.filterOptions.balancedStrategy.push(config_1.filterStringObj.balancedStrategy.high);
            }
        }
        else {
            if (!mediumLowButtonNovice.checked) {
                config_1.filterOptions.balancedStrategy = config_1.filterOptions.balancedStrategy.filter(function (a) { return a !== config_1.filterStringObj.balancedStrategy.mediumLow; });
            }
            if (!highTrackButtonNovice.checked) {
                config_1.filterOptions.balancedStrategy = config_1.filterOptions.balancedStrategy.filter(function (a) { return a !== config_1.filterStringObj.balancedStrategy.high; });
            }
        }
        checkFilters([mediumLowButton, highTrackButton]);
    });
}
exports.setupNoviceFlowEventListeners = setupNoviceFlowEventListeners;
/**
 * Setup event listeners for each filter button on the results page.
 */
function setupResultsFlowEventListeners() {
    var _a;
    // asset types
    var equityButton = document.getElementById("equity");
    var fixedIncomeButton = document.getElementById("fixed-income");
    var balancedButton = document.getElementById("balanced");
    var commodityButton = document.getElementById("commodity");
    // region filters
    var globalButton = document.getElementById("global");
    var usaButton = document.getElementById("usa");
    var canadaButton = document.getElementById("canada");
    var emergingMarketsButton = document.getElementById("emerging-markets");
    // equity filters
    var indexTrackButton = document.getElementById("index-tracking");
    var industryButton = document.getElementById("industry");
    var dividendButton = document.getElementById("dividend");
    var innovationButton = document.getElementById("innovation");
    var esgButton = document.getElementById("esg");
    var usListedButton = document.getElementById("us-listed");
    var otherStrategyButton = document.getElementById("other-strategy");
    // fixed income filters
    var corpInvestmentButton = document.getElementById("corp-investment");
    var corpNonInvestmentButton = document.getElementById("corp-non-investment");
    var governmentButton = document.getElementById("government");
    // balanced filters
    var mediumLowButton = document.getElementById("medium-low");
    var highTrackButton = document.getElementById("high");
    // filter collections
    var assetClassFilters = [equityButton, fixedIncomeButton, balancedButton, commodityButton];
    var regionFilters = [canadaButton, usaButton, globalButton, emergingMarketsButton];
    var equityStrategyFilters = [
        indexTrackButton,
        industryButton,
        dividendButton,
        innovationButton,
        esgButton,
        usListedButton,
        otherStrategyButton,
    ];
    var fixedIncomeStrategyFilters = [corpInvestmentButton, corpNonInvestmentButton, governmentButton];
    var balancedStrategyFilters = [mediumLowButton, highTrackButton];
    // label collections
    var regionLabels = document.querySelectorAll("#region-list label");
    var equityStrategyLabels = document.querySelectorAll("#strategy-equity-list label");
    var fixedIncomeStrategyLabels = document.querySelectorAll("#strategy-fixed-income-list label");
    var balancedStrategyLabels = document.querySelectorAll("#strategy-balanced-list label");
    // clear all filters button
    var clearFiltersButton = document.querySelector(".filter-clear-button");
    setupNoviceNavListeners();
    setupTableSortingEventListeners();
    disableFilters(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
    regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
    equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
    fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
    balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
    // setting up event listeners for accordion
    if (toggleButton) {
        // const resultsPageFilterAccordion = new Collapsible(filterSection, 799, Easing.easeOut);
        var toggleButtonIcon_2 = document.querySelector(".filter-toggle-button-before");
        [toggleButton, toggleButtonIcon_2].forEach(function (btn) {
            btn.addEventListener("click", function (e) {
                e.preventDefault();
                toggleAccordion(toggleButtonIcon_2, toggleButton);
            });
        });
    }
    // setting up event listeners
    equityButton === null || equityButton === void 0 ? void 0 : equityButton.addEventListener("change", function () {
        if (equityButton.checked) {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.equity];
            config_1.filterOptions.fixedIncomeStrategy = [];
            config_1.filterOptions.balancedStrategy = [];
            uncheckFilters(assetClassFilters, true, equityButton);
            uncheckFilters(__spreadArray(__spreadArray([], fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray([], fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
            enableFilters(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true));
            fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            regionLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
        }
        else {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.all];
            config_1.filterOptions.region = [];
            config_1.filterOptions.equityStrategy = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true));
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
            equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        }
        fetchDataAndPopulateFundTable();
    });
    fixedIncomeButton === null || fixedIncomeButton === void 0 ? void 0 : fixedIncomeButton.addEventListener("change", function () {
        if (fixedIncomeButton.checked) {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.fixedIncome];
            config_1.filterOptions.region = [];
            config_1.filterOptions.equityStrategy = [];
            config_1.filterOptions.balancedStrategy = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(assetClassFilters, true, fixedIncomeButton);
            uncheckFilters(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), balancedStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), balancedStrategyFilters, true));
            enableFilters(fixedIncomeStrategyFilters);
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
            equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
        }
        else {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.all];
            config_1.filterOptions.region = [];
            config_1.filterOptions.fixedIncomeStrategy = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(__spreadArray(__spreadArray([], regionFilters, true), fixedIncomeStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray([], regionFilters, true), fixedIncomeStrategyFilters, true));
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
            fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        }
        fetchDataAndPopulateFundTable();
    });
    balancedButton === null || balancedButton === void 0 ? void 0 : balancedButton.addEventListener("change", function () {
        if (balancedButton.checked) {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.balanced];
            config_1.filterOptions.region = [];
            config_1.filterOptions.equityStrategy = [];
            config_1.filterOptions.fixedIncomeStrategy = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(assetClassFilters, true, balancedButton);
            uncheckFilters(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true));
            enableFilters(balancedStrategyFilters);
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
            equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            balancedStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
        }
        else {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.all];
            config_1.filterOptions.region = [];
            config_1.filterOptions.balancedStrategy = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(__spreadArray(__spreadArray([], regionFilters, true), balancedStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray([], regionFilters, true), balancedStrategyFilters, true));
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
            balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        }
        fetchDataAndPopulateFundTable();
    });
    commodityButton === null || commodityButton === void 0 ? void 0 : commodityButton.addEventListener("change", function () {
        if (commodityButton.checked) {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.commodity];
            config_1.filterOptions.region = [];
            config_1.filterOptions.equityStrategy = [];
            config_1.filterOptions.fixedIncomeStrategy = [];
            config_1.filterOptions.balancedStrategy = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(assetClassFilters, true, commodityButton);
            uncheckFilters(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
            disableFilters(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
            equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        }
        else {
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.all];
            config_1.filterOptions.region = [];
            config_1.filterOptions.currency = [];
            uncheckFilters(regionFilters);
            disableFilters(regionFilters);
            regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
        }
        fetchDataAndPopulateFundTable();
    });
    // start of the region event listeners
    canadaButton === null || canadaButton === void 0 ? void 0 : canadaButton.addEventListener("change", function () {
        if (!usaButton.checked && !globalButton.checked) {
            if (canadaButton.checked) {
                var excludedEquityStrategyFilters = [innovationButton, esgButton, usListedButton];
                var includedEquityStrategyFilters = [
                    indexTrackButton,
                    industryButton,
                    dividendButton,
                    otherStrategyButton,
                ];
                config_1.filterOptions.equityStrategy = config_1.filterOptions.equityStrategy.filter(function (strategy) {
                    return strategy !== config_1.filterStringObj.equityStrategy.innovation &&
                        strategy !== config_1.filterStringObj.equityStrategy.esg &&
                        strategy !== config_1.filterStringObj.equityStrategy.usListed;
                });
                config_1.filterOptions.currency = [];
                uncheckFilters(excludedEquityStrategyFilters);
                disableFilters(excludedEquityStrategyFilters);
                enableFilters(includedEquityStrategyFilters);
                equityStrategyLabels.forEach(function (label) {
                    var name = label.getAttribute("for");
                    if (name === "innovation" || name === "esg" || name === "us-listed") {
                        label.classList.add("inactive");
                    }
                    else {
                        label.classList.remove("inactive");
                    }
                });
            }
            else if (emergingMarketsButton.checked) {
                config_1.filterOptions.equityStrategy = [];
                config_1.filterOptions.currency = [];
                uncheckFilters(equityStrategyFilters);
                disableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
            else {
                enableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            }
        }
        setupListener(canadaButton, config_1.filterStringObj.regions.canada, "region", true);
    });
    usaButton === null || usaButton === void 0 ? void 0 : usaButton.addEventListener("change", function () {
        if (!globalButton.checked) {
            if (usaButton.checked) {
                enableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            }
            else if (canadaButton.checked) {
                var excludedEquityStrategyFilters = [innovationButton, esgButton, usListedButton];
                var includedEquityStrategyFilters = [
                    indexTrackButton,
                    industryButton,
                    dividendButton,
                    otherStrategyButton,
                ];
                config_1.filterOptions.equityStrategy = config_1.filterOptions.equityStrategy.filter(function (strategy) {
                    return strategy !== config_1.filterStringObj.equityStrategy.innovation &&
                        strategy !== config_1.filterStringObj.equityStrategy.esg &&
                        strategy !== config_1.filterStringObj.equityStrategy.usListed;
                });
                config_1.filterOptions.currency = [];
                uncheckFilters(excludedEquityStrategyFilters);
                disableFilters(excludedEquityStrategyFilters);
                enableFilters(includedEquityStrategyFilters);
                equityStrategyLabels.forEach(function (label) {
                    var name = label.getAttribute("for");
                    if (name === "innovation" || name === "esg" || name === "us-listed") {
                        label.classList.add("inactive");
                    }
                    else {
                        label.classList.remove("inactive");
                    }
                });
            }
            else if (emergingMarketsButton.checked) {
                config_1.filterOptions.equityStrategy = [];
                config_1.filterOptions.currency = [];
                uncheckFilters(equityStrategyFilters);
                disableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
            else {
                enableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            }
        }
        setupListener(usaButton, config_1.filterStringObj.regions.us, "region", true);
    });
    globalButton === null || globalButton === void 0 ? void 0 : globalButton.addEventListener("change", function () {
        if (!usaButton.checked) {
            if (usaButton.checked) {
                enableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            }
            else if (canadaButton.checked) {
                var excludedEquityStrategyFilters = [innovationButton, esgButton, usListedButton];
                var includedEquityStrategyFilters = [
                    indexTrackButton,
                    industryButton,
                    dividendButton,
                    otherStrategyButton,
                ];
                config_1.filterOptions.equityStrategy = config_1.filterOptions.equityStrategy.filter(function (strategy) {
                    return strategy !== config_1.filterStringObj.equityStrategy.innovation &&
                        strategy !== config_1.filterStringObj.equityStrategy.esg &&
                        strategy !== config_1.filterStringObj.equityStrategy.usListed;
                });
                config_1.filterOptions.currency = [];
                uncheckFilters(excludedEquityStrategyFilters);
                disableFilters(excludedEquityStrategyFilters);
                enableFilters(includedEquityStrategyFilters);
                equityStrategyLabels.forEach(function (label) {
                    var name = label.getAttribute("for");
                    if (name === "innovation" || name === "esg" || name === "us-listed") {
                        label.classList.add("inactive");
                    }
                    else {
                        label.classList.remove("inactive");
                    }
                });
            }
            else if (emergingMarketsButton.checked) {
                config_1.filterOptions.equityStrategy = [];
                config_1.filterOptions.currency = [];
                uncheckFilters(equityStrategyFilters);
                disableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
            else {
                enableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            }
        }
        setupListener(globalButton, config_1.filterStringObj.regions.global, "region", true);
    });
    emergingMarketsButton === null || emergingMarketsButton === void 0 ? void 0 : emergingMarketsButton.addEventListener("change", function () {
        if (!usaButton.checked && !globalButton.checked) {
            if (!canadaButton.checked && emergingMarketsButton.checked) {
                config_1.filterOptions.equityStrategy = [];
                config_1.filterOptions.currency = [];
                uncheckFilters(equityStrategyFilters);
                disableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
            }
            else if (canadaButton.checked) {
                var excludedEquityStrategyFilters = [innovationButton, esgButton, usListedButton];
                var includedEquityStrategyFilters = [
                    indexTrackButton,
                    industryButton,
                    dividendButton,
                    otherStrategyButton,
                ];
                config_1.filterOptions.equityStrategy = config_1.filterOptions.equityStrategy.filter(function (strategy) {
                    return strategy !== config_1.filterStringObj.equityStrategy.innovation &&
                        strategy !== config_1.filterStringObj.equityStrategy.esg &&
                        strategy !== config_1.filterStringObj.equityStrategy.usListed;
                });
                config_1.filterOptions.currency = [];
                uncheckFilters(excludedEquityStrategyFilters);
                disableFilters(excludedEquityStrategyFilters);
                enableFilters(includedEquityStrategyFilters);
                equityStrategyLabels.forEach(function (label) {
                    var name = label.getAttribute("for");
                    if (name === "innovation" || name === "esg" || name === "us-listed") {
                        label.classList.add("inactive");
                    }
                    else {
                        label.classList.remove("inactive");
                    }
                });
            }
            else {
                enableFilters(equityStrategyFilters);
                equityStrategyLabels.forEach(function (label) { return label.classList.remove("inactive"); });
            }
        }
        setupListener(emergingMarketsButton, config_1.filterStringObj.regions.emergingMarkets, "region", true);
    });
    // start of the equity strategy event listeners
    indexTrackButton === null || indexTrackButton === void 0 ? void 0 : indexTrackButton.addEventListener("change", function () {
        setupListener(indexTrackButton, config_1.filterStringObj.equityStrategy.indexTracking, "equityStrategy", true);
    });
    industryButton === null || industryButton === void 0 ? void 0 : industryButton.addEventListener("change", function () {
        setupListener(industryButton, config_1.filterStringObj.equityStrategy.industry, "equityStrategy", true);
    });
    dividendButton === null || dividendButton === void 0 ? void 0 : dividendButton.addEventListener("change", function () {
        setupListener(dividendButton, config_1.filterStringObj.equityStrategy.dividend, "equityStrategy", true);
    });
    innovationButton === null || innovationButton === void 0 ? void 0 : innovationButton.addEventListener("change", function () {
        setupListener(innovationButton, config_1.filterStringObj.equityStrategy.innovation, "equityStrategy", true);
    });
    esgButton === null || esgButton === void 0 ? void 0 : esgButton.addEventListener("change", function () {
        setupListener(esgButton, config_1.filterStringObj.equityStrategy.esg, "equityStrategy", true);
    });
    usListedButton === null || usListedButton === void 0 ? void 0 : usListedButton.addEventListener("change", function () {
        setupListener(usListedButton, config_1.filterStringObj.currency.usd, "currency", true);
    });
    otherStrategyButton === null || otherStrategyButton === void 0 ? void 0 : otherStrategyButton.addEventListener("change", function () {
        setupListener(otherStrategyButton, config_1.filterStringObj.equityStrategy.other, "equityStrategy", true);
    });
    // start of the fixed income strategy event listeners
    corpInvestmentButton === null || corpInvestmentButton === void 0 ? void 0 : corpInvestmentButton.addEventListener("change", function () {
        setupListener(corpInvestmentButton, config_1.filterStringObj.fixedIncomeStrategy.corporate, "fixedIncomeStrategy", true);
    });
    corpNonInvestmentButton === null || corpNonInvestmentButton === void 0 ? void 0 : corpNonInvestmentButton.addEventListener("change", function () {
        setupListener(corpNonInvestmentButton, config_1.filterStringObj.fixedIncomeStrategy.nonCorporate, "fixedIncomeStrategy", true);
    });
    governmentButton === null || governmentButton === void 0 ? void 0 : governmentButton.addEventListener("change", function () {
        setupListener(governmentButton, config_1.filterStringObj.fixedIncomeStrategy.government, "fixedIncomeStrategy", true);
    });
    // start of the balanced strategy event listeners
    mediumLowButton === null || mediumLowButton === void 0 ? void 0 : mediumLowButton.addEventListener("change", function () {
        setupListener(mediumLowButton, config_1.filterStringObj.balancedStrategy.mediumLow, "balancedStrategy", true);
    });
    highTrackButton === null || highTrackButton === void 0 ? void 0 : highTrackButton.addEventListener("change", function () {
        setupListener(highTrackButton, config_1.filterStringObj.balancedStrategy.high, "balancedStrategy", true);
    });
    clearFiltersButton === null || clearFiltersButton === void 0 ? void 0 : clearFiltersButton.addEventListener("click", function (event) {
        event.preventDefault();
        config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.all];
        config_1.filterOptions.region = [];
        config_1.filterOptions.equityStrategy = [];
        config_1.filterOptions.fixedIncomeStrategy = [];
        config_1.filterOptions.balancedStrategy = [];
        config_1.filterOptions.currency = [];
        uncheckFilters(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], assetClassFilters, true), regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
        disableFilters(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], regionFilters, true), equityStrategyFilters, true), fixedIncomeStrategyFilters, true), balancedStrategyFilters, true));
        regionLabels.forEach(function (label) { return label.classList.add("inactive"); });
        equityStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        fixedIncomeStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        balancedStrategyLabels.forEach(function (label) { return label.classList.add("inactive"); });
        showSelectedFilterIcons();
        fetchDataAndPopulateFundTable();
    });
    (_a = document.querySelector("#fund-table-body")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function (event) {
        event.stopPropagation();
        var t = event.target;
        var fundRow = t.closest("tr.fund-row");
        if (!fundRow) {
            return;
        }
        var fundURL = fundRow.getAttribute("data-url") || undefined;
        window.open(fundURL, "_blank");
    });
}
exports.setupResultsFlowEventListeners = setupResultsFlowEventListeners;
/**
 * Used to sort the results table.
 * @param columnNum - column number used for sorting (0 - symbol, 1 - asset name, 2 - asset symbol, 3 - currency, 4 - region)
 * @param isAscending - boolean (true = ascending order, false = descending order)
 */
function sortTable(columnNum, isAscending) {
    sortObj = { columnNum: columnNum, isAscending: isAscending };
    var filterTable = document.querySelector(".results-table");
    if (filterTable) {
        var rows = filterTable.rows;
        var shouldSwitch = true;
        var switchCells = false;
        var i = void 0;
        while (shouldSwitch) {
            shouldSwitch = false;
            for (i = 1; i < rows.length - 1; i++) {
                switchCells = false;
                var cellA = rows[i].getElementsByTagName("td")[columnNum];
                var cellB = rows[i + 1].getElementsByTagName("td")[columnNum];
                if (isAscending) {
                    if (cellA.innerHTML.toLowerCase() > cellB.innerHTML.toLowerCase()) {
                        switchCells = true;
                        break;
                    }
                }
                else {
                    if (cellA.innerHTML.toLowerCase() < cellB.innerHTML.toLowerCase()) {
                        switchCells = true;
                        break;
                    }
                }
            }
            if (switchCells) {
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                shouldSwitch = true;
            }
        }
    }
}
/**
 * Set up the event listeners for each table header to run the sortTable function.
 */
function setupTableSortingEventListeners() {
    var _a;
    var symbolTh = document.getElementById("table-header-symbol");
    var assetNameTh = document.getElementById("table-header-asset-name");
    var assetClassTh = document.getElementById("table-header-asset-class");
    var currencyTh = document.getElementById("table-header-currency");
    var regionTh = document.getElementById("table-header-region");
    var symbolThSortOrder = true;
    var assetNameThSortOrder = false;
    var assetClassThSortOrder = false;
    var currencyThSortOrder = false;
    var regionThSortOrder = false;
    (_a = symbolTh === null || symbolTh === void 0 ? void 0 : symbolTh.querySelector("span:not([i18n])")) === null || _a === void 0 ? void 0 : _a.classList.add("ascending");
    symbolTh === null || symbolTh === void 0 ? void 0 : symbolTh.addEventListener("click", function () {
        var indicator = symbolTh === null || symbolTh === void 0 ? void 0 : symbolTh.querySelector("span:not([i18n])");
        document.querySelectorAll(".results-table thead span:not([i18n])").forEach(function (element) {
            element.classList.remove("ascending");
            element.classList.remove("descending");
        });
        assetNameThSortOrder = false;
        assetClassThSortOrder = false;
        currencyThSortOrder = false;
        regionThSortOrder = false;
        symbolThSortOrder = !symbolThSortOrder;
        sortTable(0, symbolThSortOrder);
        if (symbolThSortOrder) {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("descending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("ascending");
        }
        else {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("ascending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("descending");
        }
    });
    assetNameTh === null || assetNameTh === void 0 ? void 0 : assetNameTh.addEventListener("click", function () {
        var indicator = assetNameTh === null || assetNameTh === void 0 ? void 0 : assetNameTh.querySelector("span:not([i18n])");
        document.querySelectorAll(".results-table thead span:not([i18n])").forEach(function (element) {
            element.classList.remove("ascending");
            element.classList.remove("descending");
        });
        symbolThSortOrder = false;
        assetClassThSortOrder = false;
        currencyThSortOrder = false;
        regionThSortOrder = false;
        assetNameThSortOrder = !assetNameThSortOrder;
        sortTable(1, assetNameThSortOrder);
        if (assetNameThSortOrder) {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("descending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("ascending");
        }
        else {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("ascending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("descending");
        }
    });
    assetClassTh === null || assetClassTh === void 0 ? void 0 : assetClassTh.addEventListener("click", function () {
        var indicator = assetClassTh === null || assetClassTh === void 0 ? void 0 : assetClassTh.querySelector("span:not([i18n])");
        document.querySelectorAll(".results-table thead span:not([i18n])").forEach(function (element) {
            element.classList.remove("ascending");
            element.classList.remove("descending");
        });
        symbolThSortOrder = false;
        assetNameThSortOrder = false;
        currencyThSortOrder = false;
        regionThSortOrder = false;
        assetClassThSortOrder = !assetClassThSortOrder;
        sortTable(2, assetClassThSortOrder);
        if (assetClassThSortOrder) {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("descending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("ascending");
        }
        else {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("ascending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("descending");
        }
    });
    currencyTh === null || currencyTh === void 0 ? void 0 : currencyTh.addEventListener("click", function () {
        var indicator = currencyTh === null || currencyTh === void 0 ? void 0 : currencyTh.querySelector("span:not([i18n])");
        document.querySelectorAll(".results-table thead span:not([i18n])").forEach(function (element) {
            element.classList.remove("ascending");
            element.classList.remove("descending");
        });
        symbolThSortOrder = false;
        assetNameThSortOrder = false;
        assetClassThSortOrder = false;
        regionThSortOrder = false;
        currencyThSortOrder = !currencyThSortOrder;
        sortTable(3, currencyThSortOrder);
        if (currencyThSortOrder) {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("descending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("ascending");
        }
        else {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("ascending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("descending");
        }
    });
    regionTh === null || regionTh === void 0 ? void 0 : regionTh.addEventListener("click", function () {
        var indicator = regionTh === null || regionTh === void 0 ? void 0 : regionTh.querySelector("span:not([i18n])");
        document.querySelectorAll(".results-table thead span:not([i18n])").forEach(function (element) {
            element.classList.remove("ascending");
            element.classList.remove("descending");
        });
        symbolThSortOrder = false;
        assetNameThSortOrder = false;
        assetClassThSortOrder = false;
        currencyThSortOrder = false;
        regionThSortOrder = !regionThSortOrder;
        sortTable(4, regionThSortOrder);
        if (regionThSortOrder) {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("descending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("ascending");
        }
        else {
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.remove("ascending");
            indicator === null || indicator === void 0 ? void 0 : indicator.classList.add("descending");
        }
    });
}
/**
 * Universal function to setup the majority of filter event listeners.
 * @param radioButton - the physical input element of the filter.
 * @param arrayText - the text to pushed into the filter arrays (checking against the raw data)
 * @param assetType - the asset type to be used (equity, fixed income, balanced, commodity)
 * @param filterType - the strategy which will be used to store the array text (equityStrategy, fixedIncomeStrategy, balancedStrategy)
 */
function setupListener(radioButton, arrayText, filterType, resultsPage) {
    // only push array text if radio button is checked
    if (radioButton.checked) {
        // if the arrayText does not exist already in the filterOptions filterType array
        if (config_1.filterOptions[filterType].indexOf(arrayText) <= -1) {
            config_1.filterOptions[filterType].push(arrayText);
        }
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        config_1.filterOptions[filterType] = config_1.filterOptions[filterType].filter(function (a) { return a !== arrayText; });
    }
    if (resultsPage) {
        fetchDataAndPopulateFundTable();
    }
}
/**
 * Used to fetch data and send that data to the function that populates the results table.
 * @returns - promise to be used for chaining the opening of the accodion
 */
function fetchDataAndPopulateFundTable() {
    document.getElementById("loadingModal").classList.remove("hidden");
    return new Promise(function (resolve) {
        (0, logic_1.fetchData)().then(function (data) {
            var dissolvedArray = [];
            var filteredFunds = (0, logic_1.filterETFs)(data, config_1.filterOptions);
            var commodityOnly = !config_1.filterOptions.assetClass.includes(i18n("Balanced")) &&
                !config_1.filterOptions.assetClass.includes(i18n("Fixed Income")) &&
                !config_1.filterOptions.assetClass.includes(i18n("Equity")) &&
                !config_1.filterOptions.assetClass.includes(i18n("All"));
            // merge the four fund arrays into one
            filteredFunds.forEach(function (array) {
                dissolvedArray = dissolvedArray.concat(array);
            });
            (0, logic_1.populateResultsFundTable)(dissolvedArray, commodityOnly).then(function () {
                sortTable(sortObj.columnNum, sortObj.isAscending);
                document.getElementById("loadingModal").classList.add("hidden");
            });
            resolve(true);
        });
    });
}
/**
 * Used to open and close the accordion.
 * @param btnIcon - arrow icon beside button to display accordion
 * @param btn - button used to display accordion
 */
function toggleAccordion(btnIcon, btn) {
    var _a, _b;
    // if the accordion isn't fully open or fully closed (0px / none) don't do anything.
    if (filterSection.style.maxHeight === "0px" || filterSection.style.maxHeight === "none") {
        if (resultsPageFilterAccordion.isOpen) {
            (_a = document.getElementById("filter-collapse")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
            resultsPageFilterAccordion.close().then(function () {
                btn.innerHTML = lang === "en" ? "Show" : "Afficher";
                btnIcon.classList.remove("active");
                // show smaller filter icons based on selected filters
                showSelectedFilterIcons();
            });
        }
        else {
            (_b = document.getElementById("filter-collapse")) === null || _b === void 0 ? void 0 : _b.classList.add("hidden");
            resultsPageFilterAccordion.open().then(function () {
                btn.innerHTML = lang === "en" ? "Hide" : "Masquer";
                btnIcon.classList.add("active");
            });
        }
    }
}
function showAccordion(btnIcon, btn) {
    var _a;
    (_a = document.getElementById("filter-collapse")) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
    resultsPageFilterAccordion.open().then(function () {
        btn.innerHTML = lang === "en" ? "Hide" : "Masquer";
        btnIcon.classList.add("active");
    });
}
function hideAccordion(btnIcon, btn) {
    var _a;
    (_a = document.getElementById("filter-collapse")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
    resultsPageFilterAccordion.close().then(function () {
        btn.innerHTML = lang === "en" ? "Show" : "Afficher";
        btnIcon.classList.remove("active");
        // show smaller filter icons based on selected filters
        showSelectedFilterIcons();
    });
}
/**
 * Show all the selected filters as icons after accordion gets collasped.
 */
function showSelectedFilterIcons() {
    var filtersToShow = [];
    var allInputs = document.getElementsByTagName("input");
    Array.from(document.querySelectorAll(".selected-filter")).forEach(function (filterIcon) {
        filterIcon.classList.add("hidden-important");
    });
    Array.from(allInputs).forEach(function (input) {
        var _a, _b;
        if (input.checked) {
            if (input.id.indexOf("novice") <= -1) {
                filtersToShow.push(input.id);
                if (document.querySelector(".selected-filter-".concat(input.id))) {
                    (_a = document.querySelector(".selected-filter-".concat(input.id))) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden-important");
                }
            }
        }
        else {
            if (document.querySelector(".selected-filter-".concat(input.id))) {
                (_b = document.querySelector(".selected-filter-".concat(input.id))) === null || _b === void 0 ? void 0 : _b.classList.add("hidden-important");
            }
        }
    });
}
/**
 * Show the novice section.
 */
function showNoviceSection() {
    // filter sections
    var assetClassesSection = document.querySelector(".asset-classes");
    var equityRegionsSection = document.querySelector(".equity-regions");
    var equityStrategiesSection = document.querySelector(".equity-strategies");
    var fixedIncomeStrategiesSection = document.querySelector(".fixed-income-strategies");
    var balancedStrategiesSection = document.querySelector(".balanced-strategies");
    // results and novice form elements
    var resultsForm = document.querySelector(".results-form");
    var resultsHeader = document.querySelector(".results-header");
    var noviceForm = document.querySelector(".novice-form");
    var noviceHeader = document.querySelector(".novice-header");
    // nav buttons
    var backButton = document.getElementById("back-button");
    // const notSureButton = document.getElementById("not-sure-button") as HTMLInputElement;
    // show the novice form and header
    noviceForm.classList.remove("hidden");
    noviceHeader.classList.remove("hidden");
    // hide the results form and header
    resultsForm.classList.add("hidden");
    resultsHeader.classList.add("hidden");
    // reset the whole novice flow page back to default
    assetClassesSection.classList.remove("hidden");
    nextButton.disabled = true;
    backButton.classList.add("hidden");
    equityRegionsSection.classList.add("hidden");
    equityStrategiesSection.classList.add("hidden");
    fixedIncomeStrategiesSection.classList.add("hidden");
    balancedStrategiesSection.classList.add("hidden");
}
/**
 * Show the results section.
 */
function showResultsSection() {
    // results and novice form elements
    var resultsForm = document.querySelector(".results-form");
    var resultsHeader = document.querySelector(".results-header");
    var noviceForm = document.querySelector(".novice-form");
    var noviceHeader = document.querySelector(".novice-header");
    // hide the novice form and header
    noviceForm.classList.add("hidden");
    noviceHeader.classList.add("hidden");
    // hide the results form and header
    resultsForm.classList.remove("hidden");
    resultsHeader.classList.remove("hidden");
    focusSection(resultsForm, "h3");
}
/**
 * Uncheck all filters/inputs found in the filterlist.
 * @param filterList - Array of input btns/filters to uncheck.
 */
function uncheckFilters(filterList, all, elementToStayChecked) {
    if (all) {
        Array.from(document.getElementsByTagName("input")).forEach(function (input) {
            if (input) {
                if (elementToStayChecked) {
                    if (input.id !== elementToStayChecked.id) {
                        input.checked = false;
                    }
                }
                else {
                    input.checked = false;
                }
            }
        });
    }
    else {
        filterList.forEach(function (filter) {
            if (filter) {
                filter.checked = false;
            }
        });
    }
}
/**
 * Check all filters/inputs found in the filterlist.
 * @param filterList - Array of input btns/filters to check.
 */
function checkFilters(filterList) {
    filterList.forEach(function (filter) {
        if (filter) {
            filter.checked = true;
        }
    });
}
/**
 * Disable all filters/inputs found in the filterlist.
 * @param filterList - Array of input btns/filters to disable.
 */
function disableFilters(filterList) {
    filterList.forEach(function (filter) {
        if (filter) {
            filter.disabled = true;
        }
    });
}
/**
 * Enable all filters/inputs found in the filterlist.
 * @param filterList - Array of input btns/filters to enable.
 */
function enableFilters(filterList) {
    filterList.forEach(function (filter) {
        if (filter) {
            filter.disabled = false;
        }
    });
}
/**
 * Used to filter out any previous array items or duplicates to ensure fund list never has duplicated filters
 * @param objectItem - filterOptions array item (assetClass/region/equityStrategy/fixedIncomeStrategy/balancedStrategy)
 * @param objectArray - string array of values to filter out
 * @returns { array } - returns updated filterOptions array item
 */
function filterOutOfArray(objectItem, objectArray) {
    objectArray.forEach(function (arrayItem) {
        objectItem = objectItem.filter(function (a) { return a !== arrayItem; });
    });
    return objectItem;
}
/**
 * Used to setup event listeners on the buttons that send user back to novice section from results section.
 */
function setupNoviceNavListeners() {
    var noviceNavButton = document.querySelectorAll(".novice-filter-nav-btn");
    var elmnt = document.getElementById("novice");
    Array.from(noviceNavButton).forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            uncheckFilters([], true, undefined);
            config_1.filterOptions.assetClass = [config_1.filterStringObj.assetClass.all];
            config_1.filterOptions.region = [];
            config_1.filterOptions.equityStrategy = [];
            config_1.filterOptions.fixedIncomeStrategy = [];
            config_1.filterOptions.balancedStrategy = [];
            hideAccordion(toggleButtonIcon, toggleButton);
            hideAllBlurbs();
            showNoviceSection();
            elmnt ? elmnt.scrollIntoView({ behavior: "smooth" }) : null;
        });
    });
}
/**
 * Used to setup event listeners on the buttons that send user from novice section to results section.
 */
function setupResultsNavListeners() {
    var resultsNavButton = document.querySelectorAll(".results-filter-nav-btn");
    Array.from(resultsNavButton).forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            showResultsSection();
            fetchDataAndPopulateFundTable().then(function () {
                showAccordion(toggleButtonIcon, toggleButton);
            });
        });
    });
}
/**
 * Hide all the blurbs/definitions on the novice flow page.
 */
function hideAllBlurbs() {
    var allBlurbs;
    if (isMobile || window.matchMedia("(max-width: 640px)").matches) {
        allBlurbs = document.querySelectorAll(".mobile-blurb");
    }
    else {
        allBlurbs = document.querySelectorAll(".blurb");
    }
    Array.from(allBlurbs).forEach(function (blurb) {
        blurb.classList.add("hidden");
    });
}
function updateBlurbs() {
    // collection of labels
    var labels = document.getElementsByTagName("label");
    // determining which labels are checked
    Array.from(labels).forEach(function (label) {
        var blurbInput = document.getElementById(label.htmlFor);
        if (!blurbInput)
            return;
        var mobileBlurb = document.querySelector(".".concat(label.htmlFor, "-mobile-blurb"));
        var desktopBlurb = document.querySelector(".".concat(label.htmlFor, "-blurb"));
        if (!blurbInput.classList.contains("force-leave") &&
            (blurbInput.checked ||
                document.activeElement === blurbInput ||
                blurbInput.contains(document.activeElement) ||
                blurbInput.classList.contains("hovered"))) {
            mobileBlurb === null || mobileBlurb === void 0 ? void 0 : mobileBlurb.classList.remove("hidden");
            desktopBlurb === null || desktopBlurb === void 0 ? void 0 : desktopBlurb.classList.remove("hidden");
            mobileBlurb === null || mobileBlurb === void 0 ? void 0 : mobileBlurb.classList.add("animate-in");
            desktopBlurb === null || desktopBlurb === void 0 ? void 0 : desktopBlurb.classList.add("animate-in");
        }
        else {
            mobileBlurb === null || mobileBlurb === void 0 ? void 0 : mobileBlurb.classList.add("hidden");
            desktopBlurb === null || desktopBlurb === void 0 ? void 0 : desktopBlurb.classList.add("hidden");
            blurbInput.classList.remove("force-leave");
        }
    });
}
/**
 * Setup the event listeners for showing the defintions of the filter inputs on novice flow.
 */
function setupNoviceFlowDefinitionHovers() {
    // collection of labels used in hovering
    var labels = document.getElementsByTagName("label");
    // setting up hover functionality for inputs on novice flow
    Array.from(labels).forEach(function (label, i) {
        var blurbInput = document.getElementById(label.htmlFor);
        var desktopBlurb = document.querySelector(".".concat(label.htmlFor, "-blurb"));
        var describedBy = [];
        if (blurbInput && desktopBlurb) {
            if (!desktopBlurb.id)
                desktopBlurb.id = "desktop-blurb-uid-".concat(i);
            describedBy.push(desktopBlurb.id);
        }
        if (blurbInput) {
            if (describedBy.length) {
                blurbInput.setAttribute("aria-describedby", describedBy.join(" "));
            }
            else {
                blurbInput.removeAttribute("aria-describedby");
            }
        }
        blurbInput === null || blurbInput === void 0 ? void 0 : blurbInput.addEventListener("change", function () {
            updateBlurbs();
        });
        blurbInput === null || blurbInput === void 0 ? void 0 : blurbInput.addEventListener("focus", function () {
            updateBlurbs();
        });
        blurbInput === null || blurbInput === void 0 ? void 0 : blurbInput.addEventListener("blur", function () {
            updateBlurbs();
        });
        label.addEventListener("mouseleave", function () {
            blurbInput === null || blurbInput === void 0 ? void 0 : blurbInput.classList.remove("hovered");
            if (blurbInput && !blurbInput.checked)
                blurbInput.classList.add("force-leave");
            updateBlurbs();
        });
        label.addEventListener("mouseenter", function () {
            blurbInput === null || blurbInput === void 0 ? void 0 : blurbInput.classList.add("hovered");
            updateBlurbs();
        });
    });
}
/**
 * Hide all the selected filter texts
 */
function hideAllFilterText() {
    var allFilterText = document.querySelectorAll(".filter-text");
    Array.from(allFilterText).forEach(function (filterText) {
        filterText.classList.add("hidden-important");
    });
}
/**
 * Show all the selected filter texts.
 */
function showAllFilterText() {
    var allFilterText = document.querySelectorAll(".filter-text");
    Array.from(allFilterText).forEach(function (filterText) {
        filterText.classList.remove("hidden-important");
    });
}
// Let Selected Filter Text
function setupSelectedFilterText() {
    // collection of labels used in hovering
    var selectedFilter = document.getElementsByClassName("selected-filter");
    Array.from(selectedFilter).forEach(function (filterIcon) {
        var filterText = (filterIcon.children[1] || null);
        filterIcon.addEventListener("click", function () {
            if (isMobile || window.matchMedia("(max-width: 640px)").matches) {
                hideAllFilterText();
                if (filterText) {
                    filterText.classList.remove("hidden-important");
                }
            }
            else {
                showAllFilterText();
            }
        });
    });
}
var clientWidth = document.documentElement.clientWidth;
function onWindowResize() {
    if (document.documentElement.clientWidth === clientWidth) {
        return false;
    }
    clientWidth = document.documentElement.clientWidth;
    if (window.matchMedia("(max-width: 640px)").matches) {
        hideAllFilterText();
    }
    else {
        showAllFilterText();
    }
}
window.addEventListener("resize", onWindowResize);
//# sourceMappingURL=module.js.map